<template>
    <div class="phone-wrap">
        <!--  持有者更改弹框 -->
        <a-modal
            title='持有者更改'
            :visible="visiblePhone"
            :width="700"
            :confirmLoading="confirmLoading"
            @cancel="closeModalPhone"
            :footer='null'
            >
            <div class="mb16">
                <member-card :ticketData="ticketData" :showOwner="true"></member-card>
            </div>
            <a-form :form="form">
                <a-form-item label="更换票/卡券持有者手机号为" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
                    <a-input
                        placeholder="请输入"
                        @change="nowPhoneChange"
                        v-decorator="['phone',{rules: [{required: true, message: '请输入手机号'}, {pattern: /^(\d{11})$/, message: '请输入正确的手机号'}]}]"
                    />
                </a-form-item>
                <remark :labelSpan="6" :wrapperSpan="18" operateCode="OwnerChange" />
                <shop :shops="ticketData.suitShopReserveStockConfigs" :labelSpan="6" :wrapperSpan="18"/>
            </a-form>
            <div v-show="Boolean(visiblePhone && giveSelectorLength)">
                <a-divider></a-divider>
                <div class="give-info-container">
                    <div class="mb8">
                        <span class="font-bigger text-color-85">赠品信息</span>
                        <span class="text-primary ml24">该持有者更改票券为活动主商品，是否将购买该商品所赠送的赠品进行持有者更改</span>
                    </div>
                    <member-order-give-selector :ticketGivenId="ticketData.userTicketNo" :owner="ticketData.phone" type="changeOwner" ref="giveSelector"></member-order-give-selector>
                </div>
            </div>
            <div style="margin-top: 16px;" class="flex flex-end phonePop">
                <a-popconfirm placement="topRight" :visible="comfirmChange" icon=" " @cancel="comfirmChange = false" @confirm="showConfirm">
                    <template slot="title">
                        <section class="redate-wrap-pop">
                            持有者更改操作确认框
                            <p></p>
                            <p>票券名称：{{ticketData.showName}}</p>
                            <p>原持有者手机号：{{ticketData.phone}}</p>
                            <p>更改后持有者手机号：{{nowUserPhone}}</p>
                            <p></p>
                        </section>
                    </template>
                    <a-button @click="comfirmPhone" class="pop-fix" type="primary">提 交</a-button>
                </a-popconfirm>
            </div>
        </a-modal>
        <!-- 操作2次确认 -->
        <a-modal
        centered
        :maskClosable="false"
        :destroyOnClose="true"
        title="持有者变更"
        :visible="visibleConfirm2"
        @cancel="visibleConfirm2 = false"
        :width="600"
        >
            <div class="text-center font-bigger text-color-85 mb16">{{ticketData.showName || ticketData.ticketName}}</div>
            <div class="text-primary mb16">活动商品确认：</div>
            <a-table
            bordered
            :columns="columns"
            :rowKey="(item, index) => index"
            :dataSource="confirmDataSource"
            :pagination="false"
            :scroll="{y: 250}"
            >
                <template slot="goodsType" slot-scope="key, row, index">
                    {{["", "票券","课程","零售","餐品", "储值", "售后", "优惠券", "积分"][key]}}
                </template>
            </a-table>
            <template slot="footer">
                <a-button @click="visibleConfirm2 = false">取消</a-button>
                <a-button type="primary" :loading="confirmLoading" @click="handleCreatePhone(false)">确定</a-button>
            </template>
        </a-modal>
        <!-- 操作积分、储值余额不足提示 -->
        <a-modal
        centered
        :maskClosable="false"
        :destroyOnClose="true"
        title="提示"
        :visible="visibleConfirm"
        @cancel="visibleConfirm = false"
        :width="420"
        >
            <div>
                该笔订单积分、储值余额不足，是否继续进行持有者更改？
            </div>
            <div>
                持有者更改后，该账户积分、储值余额将会清0。
            </div>
            <template slot="footer">
                <a-button @click="visibleConfirm = false">取消</a-button>
                <a-button type="primary" :loading="confirmLoading" @click="handleCreatePhone(true)">确定</a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>

    /**
     * 持有者更改弹框组件
     * @prop {Object} ticketData 基础卡对象
     * @prop {Boolean} visiblePhone 控制弹窗是否显示
     *
     * @func closeModalPhone 通知父组件关闭弹窗
     *
     */
    import memberCard from "@/components/modules/order/member-card.component";
    import memberOrderGiveSelector from '@/components/modules/order/member-order-give-selector.component';
    import remark from '@/components/modules/platform/remark.component';
    import shop from '@/components/modules/platform/shop.component';

    let columns = [
        {
            title: '赠送商品名称',
            dataIndex: 'goodsName',
        },
        {
            title: '赠送商品类型',
            dataIndex: 'goodsType',
            scopedSlots: { customRender: "goodsType" },
            width: 100
        },
        {
            title: '赠送数量',
            dataIndex: 'goodsNum',
            width: 100
        }
    ];
    export default {
        name: "member-order-phone",
        zh: "持有者更改弹框组件",
        data() {
            return {
                columns,
                confirmLoading: false,
                visibleConfirm: false,
                visibleConfirm2: false,
                confirmDataSource: [],
                giveSelectorLength: 0,
                comfirmChange: false,
                nowUserPhone: "",
            };
        },
        props: {
            ticketData: {type: Object},
            visiblePhone: {type: Boolean},
        },
        components: {
            memberCard,
            memberOrderGiveSelector,
            remark,
            shop
        },
        methods: {
            /**
             * @nowPhoneChange 手机号码输入回调
             */
            nowPhoneChange (e) {
                this.nowUserPhone = e.target.value;
            },
            comfirmPhone() {
                this.form.validateFields((errors, values) => {
                    if (errors) {
                        return false;
                    }
                    this.comfirmChange = true;
                });
            },
            /**
             * @showConfirm 赠品确认
             */
            showConfirm() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        let { giveSelector } = this.$refs;
                        if (Boolean(giveSelector)) {
                            this.confirmDataSource = giveSelector.getSelectedRows();
                        }
                        if (!Boolean(giveSelector) || !Boolean(this.confirmDataSource.length)) {
                            this.handleCreatePhone(false);
                            return false;
                        }
                        this.visibleConfirm2 = true;
                        this.comfirmChange = false;
                    }
                })
            },
            handleCreatePhone(ignoreNotEnough) {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        const shopItem = JSON.parse(values.shop);
                        let giveActivityDetails = [];
                        let { ticketData } = this;
                        let { giveSelector } = this.$refs;
                        if (Boolean(giveSelector) && giveSelector.getSelectedRows()) {
                            giveActivityDetails.push({
                                isMainGoods: true,
                                operateNum: 1,
                                operateObjectCategory: "TICKET",
                                userTicketNo: ticketData.userTicketNo,
                            })
                            giveSelector.getSelectedRows().forEach(el => {
                                switch (el.goodsType) {
                                    case 1:
                                        giveActivityDetails.push({
                                            operateNum: el.goodsNum,
                                            operateObjectCategory: "TICKET",
                                            userTicketNo: el.userTicketNo,
                                        })
                                        break;
                                    case 7:
                                        giveActivityDetails.push({
                                            operateNum: el.goodsNum,
                                            operateObjectCategory: "COUPON",
                                            userCouponNo: el.userCouponId,
                                        })
                                        break;
                                    case 5:
                                        giveActivityDetails.push({
                                            operateNum: el.goodsNum,
                                            balanceCardId: el.goodsId,
                                            operateObjectCategory: "BALANCE",
                                        })
                                        break;
                                    case 8:
                                        giveActivityDetails.push({
                                            operateObjectCategory: "POINT",
                                            pointNum: el.grantNum,
                                        })
                                        break;
                                    default:
                                        break;
                                }
                            })
                        }
                        this.confirmLoading = true;
                        this.$api.order.ownerChange({
                            body: {
                                giveActivityDetails,
                                goods: this.ticketData.isActivity ? this.ticketData.giveGrantId : this.ticketData.userTicketNo,
                                goodsType: this.ticketData.isActivity ? "ACTIVITY" : "TICKET",
                                userId: this.ticketData.userId,
                                nowUserPhone: values.phone,
                                phone: this.ticketData.phone,
                                remark: values.remark,
                                remarkCategoryCode: values.remarkCategoryCode,
                                remarkCategoryName: values.remarkCategoryName,
                                shopId: shopItem.id,
                                shopName: shopItem.name,
                            }
                        }).then(res => {
                            this.$message.success('操作成功');
                            this.visibleConfirm = false;
                            this.visibleConfirm2 = false;
                            this.confirmLoading = false;
                            this.confirmDataSource = [];
                            this.closeModalPhone();
                        }).catch(err => {
                            this.confirmLoading = false;
                            if (err && err.code === 200001) {
                                this.visibleConfirm = true;
                                this.$message.error(err.msg);
                            }
                        });
                    }
                })
            },
            closeModalPhone() {
                this.comfirmChange = false;
                this.confirmLoading = false;
                setTimeout(() => {
                    this.$emit('changeVisiblePhone', false);                
                }, 500);
                this.form.resetFields();
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this)
        },
        created() {},
        updated() {},
        mounted() {
        },
        computed: {},
        watch: {
            // 'ticketData'(val) {
            //     this.ticketData = val;
            // },
            'visiblePhone'(val) {
                if (val) {
                    this.$nextTick(() => {
                        this.$refs.giveSelector.getUserTicketGiveInfoVo().then(res => {
                            this.giveSelectorLength = res && res.length;
                        })
                    })
                } else {
                    this.comfirmChange = false;
                }
            }
        }
    };
</script>

<style lang="scss">
    .give-info-container {
        background-color: #f3f3f3;
        padding: 14px;
    }
</style>
